
import { withInstall } from "../../utils/install";
import APopconfirm from "./src/main.vue";
APopconfirm.name = "ltAPopconfirm";
export const ltAPopconfirm = withInstall(APopconfirm);
export default ltAPopconfirm;

